import { ParetoColumnDataset } from './pareto';
import { _checkPointerOverColumn } from '../misc/column3d-utils';

let
  /**
   * Helper function to create a RedRaphael group.
   * @param  {string} groupName                Name of the group to be created.
   * @param  {Element} parentContainer         The parent container in which the group will be appended.
   * @param {Object} dataset The concerned dataset
   * @return {Element}                         The group that was created.
   */
  createGroup = function (groupName, parentContainer, dataset) {
    var animationManager = dataset.getFromEnv('animationManager');
    return animationManager.setAnimation({
      el: 'group',
      attr: {name: groupName},
      container: parentContainer,
      state: 'appearing',
      component: dataset,
      label: 'group'
    });
  };

class ParetoColumn3DDataset extends ParetoColumnDataset {
  /**
   * Function that retunr the nearest plot details
   * @param {number} chartX x-axis position of the mouse cordinate
   * @param {number} chartY x-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest polt and whether it is hovered or not
   */
  _getHoveredPlot (chartX, chartY) {
    var dataset = this,
      xAxis = dataset.getFromEnv('xAxis'),
      x,
      pX;

    x = xAxis.getValue(chartX);
    pX = Math.round(x);
    // Checking for overlap between two cosecutive column plots along x-axis
    return (pX - x > 0 ? _checkPointerOverColumn.call(dataset, pX, chartX, chartY) ||
      _checkPointerOverColumn.call(dataset, pX - 1, chartX, chartY) :
      _checkPointerOverColumn.call(dataset, pX + 1, chartX, chartY) ||
      _checkPointerOverColumn.call(dataset, pX, chartX, chartY));
  }
  /**
   * function to create group for dataset
   */
  createContainer () {
    var dataset = this,
      parent = dataset.getLinkedParent();

    !dataset.getContainer('labelGroup') && dataset.addContainer('labelGroup',
      createGroup('label-group', parent.getChildContainer('vcanvasLabelGroup'), dataset)
        .attr('class', 'fusioncharts-datalabels'));
  }
}

export { ParetoColumn3DDataset };
